export default function resetUrlToHome(sso) {
  const current = new URLSearchParams(window.location.search)
  const next = new URLSearchParams()

  const p = current.get('p')
  if (p) next.set('p', p)

  const ssoValue = sso || current.get('sso') || current.get('z') || current.get('cptok')
  if (ssoValue) next.set('sso', ssoValue)

  const queryString = next.toString()
  window.history.pushState(
    {},
    '',
    `${process.env.PUBLIC_URL}/?` + queryString
  )
}
